import type { Form106Fields } from './form106';

/**
 * The employer a Form 106 is from: its deductions file, else the employer's name; a form with neither counts as its
 * own employer (`#<index>`). One source for the employers card, the refund estimate and the early-stop table.
 */
export const form106Payer = (d: Pick<Form106Fields, 'deductionsFile' | 'employerName'>, index: number): string => d.deductionsFile ?? d.employerName ?? `#${index}`;

/** How many different employers a tax year's Form 106s come from. */
export const form106Employers = (docs: readonly Pick<Form106Fields, 'deductionsFile' | 'employerName'>[]): number => new Set(docs.map(form106Payer)).size;
